/**
 * Popup Handlers
 * Handle popup open/close interactions (filter popups, modals)
 */

/**
 * Setup popup close handlers
 * Closes filter popups when clicking outside or on "View all" button
 */
export function setupPopupCloseHandlers() {
  // Handle filter popup open/close
  document.addEventListener('click', (e) => {
    const target = e.target;

    // Check if click is on "View all" button
    const isPopupBtn = target.classList.contains(
      'rd-search-results__filter-fields-popup-btn'
    );

    if (isPopupBtn) {
      // Toggle popup
      const container = target.closest(
        '.rd-search-results__filter-fields'
      );
      if (!container) return;

      const popup = container.querySelector(
        '.rd-search-results__filter-fields-popup'
      );
      if (!popup) return;

      // Close other popups first
      document
        .querySelectorAll('.rd-search-results__filter-fields-popup.open')
        .forEach((otherPopup) => {
          if (otherPopup !== popup) {
            otherPopup.classList.remove('open');
          }
        });

      // Toggle current popup
      popup.classList.toggle('open');
      e.stopPropagation();
      return;
    }

    // Check if click is inside popup
    const isInsidePopup = target.closest(
      '.rd-search-results__filter-fields-popup'
    );

    // If click is outside popup, close all popups
    if (!isInsidePopup && !isPopupBtn) {
      document
        .querySelectorAll('.rd-search-results__filter-fields-popup.open')
        .forEach((popup) => {
          popup.classList.remove('open');
        });
    }
  });

  console.log('✅ Popup close handlers setup');
}

console.log('📦 Popup handlers module loaded');
